import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1F1E1D",
      "fill-rule": "evenodd",
      d: "M3.363 3.364a.9.9 0 0 1 1.273 0l2.502 2.501.034.035 3.332 3.331.022.022 4.22 4.22.022.023 3.33 3.33.035.035 2.503 2.503a.9.9 0 1 1-1.273 1.272l-2.035-2.035A11.4 11.4 0 0 1 12 19.9c-5.071 0-9.117-3.165-10.839-7.573a.9.9 0 0 1 0-.654c.828-2.12 2.191-3.952 3.954-5.285L3.363 4.636a.9.9 0 0 1 0-1.272m3.04 4.311C4.911 8.743 3.725 10.237 2.971 12c1.545 3.611 4.894 6.1 9.028 6.1a9.6 9.6 0 0 0 3.983-.844l-1.936-1.936A3.9 3.9 0 0 1 8.68 9.953zm3.618 3.62q-.12.332-.121.705a2.1 2.1 0 0 0 2.806 1.979zM12 5.9q-.596 0-1.166.067a.9.9 0 1 1-.208-1.788Q11.3 4.1 12 4.1c5.07 0 9.117 3.165 10.838 7.573a.9.9 0 0 1 0 .654 12.5 12.5 0 0 1-1.676 3.004.9.9 0 1 1-1.435-1.087c.516-.681.954-1.434 1.3-2.244C19.482 8.389 16.133 5.9 12 5.9",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }